<template>
    <v-row class="pb-md-2 pt-md-n16" style="height: 400px; overflow-y: scroll">
        <v-col
            md="4"
            cols="12"
            v-for="tech, index in selectedDevice.tech_details" 
            :key="index"
        >
            <v-card
                outlined
                class="pa-3"
                height="100%"
            >
                <h3 class="font-weight-light">{{ tech.title }}</h3>
                <v-divider></v-divider>
                <h5 class="font-weight-light grey--text text-justify pt-md-3">{{ tech.description }}</h5>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import {mapState} from 'vuex'

    export default{
        name:'DeviceSpecs',
        data : ()=>({
        }),
        computed:{
            ...mapState("deviceManagement", {
                selectedDevice: state => state.selectedDevice,
            })
        }
    }
</script>

